
<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <div class="dropdown">
          <button
            class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i class="flaticon-plus position-relative ms-5 fs-12"></i>
            Ajouter une opération
          </button>
          <ul class="dropdown-menu">
            <li>
              <router-link to="/ajouter-encaissement" class="dropdown-item d-flex align-items-center">
                Ajouter un encaissement
              </router-link>
            </li>
            <li>
              <router-link to="/ajouter-decaissement" class="dropdown-item d-flex align-items-center">
                Ajouter un décaissement
              </router-link>
            </li>
          </ul>
        </div>
        <div class="dropdown ms-3">
          <button
            class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-primary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            Filtrer par type
          </button>
          <ul class="dropdown-menu">
            <li><a class="dropdown-item" href="javascript:void(0);" @click="setFilter('toutes')">Toutes</a></li>
            <li><a class="dropdown-item" href="javascript:void(0);" @click="setFilter('encaissement')">Encaissements</a></li>
            <li><a class="dropdown-item" href="javascript:void(0);" @click="setFilter('decaissement')">Décaissements</a></li>
          </ul>
        </div>
      </div>
      <div class="d-flex align-items-center">
        <form class="search-box position-relative me-20" @submit.prevent="rechercher">
          <input
            type="text"
            v-model="searchTerm"
            @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0"
            placeholder="Rechercher une opération"
          />
          <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="text-nowrap align-middle mb-0 table">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Type d'opération
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Client
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Montant
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Motif
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Référence
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="op in filteredOperations" :key="op.id">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ op.type }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ op.client?.nom || '-' }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ op.montant || 0 }} Fcfa
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ op.motif?.nom || '-' }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ op.referenceDoc || '-' }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text pe-0">
                <div class="dropdown">
                  <span
                    class="badge text-white bg-primary fs-15 dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Actions
                    <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li>
                      <router-link
                        :to="`/billetage/${op.type.toLowerCase()}/${op.id}`"
                        class="dropdown-item d-flex align-items-center"
                      >
                        <i class="flaticon-eye lh-1 me-8 position-relative top-1"></i>
                        Afficher les détails de l'opération
                      </router-link>
                    </li>
                    <li v-if="checkPermission('delete_operation')">
                      <a
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        @click="deleteOperation(op.id)"
                      >
                        <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                        Supprimer
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
            <tr v-if="filteredOperations.length === 0">
              <td colspan="6" class="text-center text-muted">
                Aucune opération trouvée.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent
          :page="page"
          :totalPages="totalPages"
          :totalElements="totalElements"
          :limit="limit"
          @paginate="handlePaginate"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, computed } from 'vue';
import Swal from 'sweetalert2';
import ApiService from '@/services/ApiService';
import { suppression, error } from '@/utils/utils';
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from '@/services/JwtService';

interface Billetage {
  libelle: string;
  qteBillet: number;
  montant: number;
  valueAct: number;
  monnaie: number;
}

interface Client {
  nom: string;
  id: number;
}

interface Motif {
  nom: string;
  id: number;
  description: string;
}

interface Operation {
  id: number;
  type: string;
  montant: number;
  motifId: number | null;
  motif?: Motif | null;
  client: Client | null;
  referenceDoc: string | null;
  billetagesEncaissement: Billetage[] | null;
  montantTotalEncaissement: number | null;
  billetagesSortie: Billetage[] | null;
  montantTotalSortie: number | null;
  date: Date;
}

export default defineComponent({
  name: 'ListeOperation',
  components: {
    PaginationComponent,
  },
  setup() {
    const encaissements = ref<Array<Operation>>([]);
    const decaissements = ref<Array<Operation>>([]);
    const motifs = ref<Motif[]>([]);
    const searchTerm = ref('');
    const filterType = ref('toutes');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    const currentPage = ref(1);
    const typeOperationId = ref<number>(1);

    const totalEncaissement = computed(() => {
      return encaissements.value.reduce((sum, op) => sum + (op.montant || 0), 0);
    });

    const totalDecaissement = computed(() => {
      return decaissements.value.reduce((sum, op) => sum + (op.montant || 0), 0);
    });

    const filteredOperations = computed(() => {
      if (filterType.value === 'toutes') {
        return [...encaissements.value, ...decaissements.value];
      } else if (filterType.value === 'encaissement') {
        return encaissements.value;
      } else if (filterType.value === 'decaissement') {
        return decaissements.value;
      }
      return [];
    });

    const fetchMotifs = async (typeOperationId: number) => {
      try {
        const { data } = await ApiService.query(`/motifs/by-type`, {
          params: { typeOperationId },
        });
        console.log('Motifs API response:', data);
        motifs.value = data.data.data;
      } catch (err) {
        console.error('Erreur lors de la récupération des motifs:', err);
        error('Erreur lors de la récupération des motifs');
      }
    };

    const getAllOperations = async (pageNum = 1, limitNum = 10, search = '', type = '') => {
  try {
    let url = `/operations?page=${pageNum}&limit=${limitNum}`;
    if (search.trim()) {
      url += `&mot=${encodeURIComponent(search.trim())}`;
    }
    if (type && type !== 'toutes') {
      const apiType = type === 'decaissement' ? 'Décaissement' : 'Encaissement';
      url += `&type=${encodeURIComponent(apiType)}`;
    }
    const { data } = await ApiService.get(url);
    console.log('API Response:', data);

    const operations = data.data.data || [];
    encaissements.value = operations.filter(op => {
      const normalizedType = op.type?.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      return normalizedType === 'encaissement';
    });
    decaissements.value = operations.filter(op => {
      const normalizedType = op.type?.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      return normalizedType === 'decaissement';
    });

    console.log('Encaissements:', encaissements.value);
    console.log('Décaissements:', decaissements.value);

    totalPages.value = data.data.totalPages || 1;
    totalElements.value = data.data.totalElements || operations.length;
    limit.value = data.data.limit || limitNum;
    currentPage.value = pageNum;
  } catch (err: any) {
    console.error('Error fetching operations:', err);
    error(err.response?.data?.message || 'La liste des opérations n\'a pas été récupérée');
  }
};

    const setFilter = (type: string) => {
      console.log('Setting filter to:', type);
      filterType.value = type.toLowerCase();
      page.value = 1;
      rechercher();
    };

    const rechercher = () => {
      const search = searchTerm.value.trim() || '';
      getAllOperations(page.value, limit.value, search, filterType.value);
    };

    const deleteOperation = async (id: number) => {
      try {
        const { data } = await ApiService.delete(`/operations/${id}`);
        Swal.fire({
          text: data.message || 'Opération supprimée avec succès',
          toast: true,
          icon: 'success',
          position: 'top-right',
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          heightAuto: false,
        });
        encaissements.value = encaissements.value.filter((op) => op.id !== id);
        decaissements.value = decaissements.value.filter((op) => op.id !== id);
      } catch (err: any) {
        Swal.fire({
          text: err.response?.data?.message || 'Erreur lors de la suppression',
          icon: 'error',
          buttonsStyling: false,
          confirmButtonText: 'Réessayer',
          heightAuto: false,
          customClass: {
            confirmButton: 'btn fw-semibold btn-light-danger',
          },
        });
      }
    };

    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name: string) => {
      return privileges.value.includes(name);
    };

    onMounted(() => {
      fetchMotifs(typeOperationId.value);
      getAllOperations();
    });

    return {
      encaissements,
      decaissements,
      checkPermission,
      getAllOperations,
      deleteOperation,
      suppression,
      page,
      totalPages,
      limit,
      totalElements,
      handlePaginate: ({ page_, limit_ }: { page_: number; limit_: number }) => {
        page.value = page_;
        getAllOperations(page_, limit_, searchTerm.value, filterType.value);
      },
      rechercher,
      searchTerm,
      filterType,
      currentPage,
      totalEncaissement,
      totalDecaissement,
      setFilter,
      filteredOperations,
    };
  },
});
</script>
 
 
 <style scoped>
.card {
  padding: 0;
  margin-bottom: 25px;
  background-color: #fff;
  border: none;
  border-radius: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
 
.card-head {
  padding: 15px;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
 
@media (min-width: 576px) {
  .card-head {
    padding: 20px;
  }
}
 
@media (min-width: 768px) {
  .card-head {
    padding: 25px;
  }
}
 
.card-body {
  padding: 15px;
}
 
@media (min-width: 576px) {
  .card-body {
    padding: 20px;
  }
}
 
@media (min-width: 768px) {
  .card-body {
    padding: 25px;
  }
}
 
.default-btn {
  padding: 11px 25px;
  font-size: 15px;
  border-radius: 4px;
}
 
@media (min-width: 768px) {
  .default-btn {
    padding: 12px 30px;
    font-size: 16px;
  }
}
 
.bg-success {
  background-color: #28a745 !important;
}
 
.bg-primary {
  background-color: #0a59a4 !important;
}
 
.form-control {
  border: none;
  border-bottom: 1px solid #dee2e6;
  border-radius: 0;
  padding: 8px 0;
  font-size: 15px;
}
 
.form-control:focus {
  box-shadow: none;
  border-color: #0a59a4;
}
 
.search-box button {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
 
.table th, .table td {
  vertical-align: middle;
  font-size: 13px;
}
 
.table th {
  text-transform: uppercase;
  color: #6c757d;
}
 
.table td {
  color: #343a40;
}
 
.dropdown-menu {
  min-width: 150px;
}
 
.dropdown-item {
  font-size: 14px;
  padding: 8px 15px;
}
 
.dropdown-item i {
  font-size: 14px;
}
 
.billetage-details {
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 4px;
}
 
.billetage-details h3 {
  margin-bottom: 5px;
}
 
.container-tight {
  margin: 0;
  padding: 2px 0;
}
 
.border-primary {
  border-color: #0a59a4 !important;
}
</style>
 